var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 6.66683C12.0002 5.60596 11.5787 4.58855 10.8286 3.8384C10.0784 3.08826 9.06103 2.66683 8.00016 2.66683C6.9393 2.66683 5.92188 3.08826 5.17174 3.8384C4.42159 4.58855 4.00016 5.60596 4.00016 6.66683V12.0002H12.0002V6.66683ZM13.3335 12.4448L13.6002 12.8002C13.6373 12.8497 13.6599 12.9086 13.6655 12.9702C13.671 13.0319 13.6593 13.0939 13.6316 13.1492C13.604 13.2046 13.5614 13.2512 13.5087 13.2837C13.4561 13.3163 13.3954 13.3335 13.3335 13.3335H2.66683C2.60493 13.3335 2.54424 13.3163 2.49159 13.2837C2.43893 13.2512 2.39637 13.2046 2.36869 13.1492C2.341 13.0939 2.32928 13.0319 2.33484 12.9702C2.3404 12.9086 2.36302 12.8497 2.40016 12.8002L2.66683 12.4448V6.66683C2.66683 5.25234 3.22873 3.89579 4.22893 2.89559C5.22912 1.8954 6.58567 1.3335 8.00016 1.3335C9.41465 1.3335 10.7712 1.8954 11.7714 2.89559C12.7716 3.89579 13.3335 5.25234 13.3335 6.66683V12.4448ZM6.3335 14.0002H9.66683C9.66683 14.4422 9.49123 14.8661 9.17867 15.1787C8.86611 15.4912 8.44219 15.6668 8.00016 15.6668C7.55813 15.6668 7.13421 15.4912 6.82165 15.1787C6.50909 14.8661 6.3335 14.4422 6.3335 14.0002V14.0002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.9c6b01dfd3c22250882252bf7cc5ec33.svg";
export { ForwardRef as ReactComponent };